import { render, staticRenderFns } from "./whitelabelPanel.vue?vue&type=template&id=0931b26d&"
import script from "./whitelabelPanel.vue?vue&type=script&lang=js&"
export * from "./whitelabelPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports